import { RemoveBrandFanGroupMemberActionTypes } from '@store/brandFans'

export const removeBrandFanGroupMember = (
  identityId: number,
  groupId: number,
  params?: {
    campaignId?: number
    submissionId?: number
    influencerId?: number
    memberId?: number
    refetchIdentity?: boolean
  },
) => ({
  payload: { identityId, groupId, ...params },
  type: RemoveBrandFanGroupMemberActionTypes.REMOVE_MEMBER_REQUEST,
})

export const removeBrandFanGroupMemberSuccess = (identityId: number, groupId: number) => ({
  payload: { identityId, groupId },
  type: RemoveBrandFanGroupMemberActionTypes.REMOVE_MEMBER_SUCCESS,
})

export const removeBrandFanGroupMemberError = (groupId: number, error: any) => ({
  payload: { groupId, error },
  type: RemoveBrandFanGroupMemberActionTypes.REMOVE_MEMBER_ERROR,
})
